jQuery(document).ready(function($) {
  var $product_grid = $('.product-list-container').isotope({
    itemSelector: '.product-item',
    layoutMode: 'fitRows'
  });

  $product_grid.on( 'arrangeComplete',
	  function( event, filteredItems ) {
      if(filteredItems.length == 0) {
        $('.product-not-found').removeClass('hide');
      } else {
        $('.product-not-found').addClass('hide');
      }
	  }
	);

  $('#filter-dog-size, #filter-collection').on('change', function() {
    var prod_filters = [];
    $('.product-quiz-header').addClass('hide');

    if($('#filter-dog-size').val() !== '*') {
      prod_filters.push('[data-sizes*="'+$('#filter-dog-size').val()+'"]');
    } else {
      // prod_filters.push('.product-item[data-sizes]');
    }

    // console.log($('#filter-collection').val());

    // if($('#filter-collection').val() !== null) {
    //   var temp_collection_filter = $('#filter-collection').val();
    //   for(var col = 0; col < temp_collection_filter.length; col++) {
    //     if(temp_collection_filter[col] !== '*') {
    //       prod_filters.push('[data-collections*="'+temp_collection_filter[col]+'"]');
    //     }
    //   }
    // }

    if($('#filter-collection').val() !== '*' && $('#filter-collection').val() !== null) {
      prod_filters.push('[data-collections*="'+$('#filter-collection').val()+'"]');
    } else {
      // prod_filters.push('.product-item[data-collections]');
    }

    // console.log(prod_filters.join(''));

    $product_grid.isotope({
      filter: prod_filters.join('')
    });

  });

  var quizName = urlParam('quiz_name');
  if(quizName) {
    $('.product-quiz-header [data-dog-name]').text(quizName.replace('+', ' '));
  }

  if(urlParam('dog_sizes') || urlParam('life_stage') || urlParam('formula')) {
    var filterDogSize   = urlParam('dog_sizes'),
        filterLifeStage = urlParam('life_stage'),
        filterFormula   = urlParam('formula');

    console.log(filterDogSize, filterLifeStage, filterFormula);

    var size_filters = [],
        prod_filters = [],
        final_filters = [];

    switch(filterDogSize) {
      case 'xxs':
      case 'xs':
        size_filters.push('[data-sizes*="X-S"]');
        break;
      case 'xs-s':
        size_filters.push('[data-sizes*="X-S"]');
        size_filters.push('[data-sizes*="S"]');
        size_filters.push('[data-sizes*="One Size"]');
        break;
      case 'm':
        size_filters.push('[data-sizes*="M"]');
        size_filters.push('[data-sizes*="One Size"]');
        break;
      case 'l':
      case 'l-xl':
        size_filters.push('[data-sizes*="L"]');
        size_filters.push('[data-sizes*="XL"]');
        size_filters.push('[data-sizes*="One Size"]');
        break;
    }

    // if(filterLifeStage) {
    //   prod_filters.push('[data-collections*="'+filterLifeStage+'"]');
    // }

    if(filterLifeStage == null || filterLifeStage !== 'treats-for-puppies') {
      if(filterFormula) {
        prod_filters.push('[data-collections*="'+filterFormula+'"]');
      }
    } else {
      prod_filters.push('[data-collections*="'+filterLifeStage+'"]');
    }

    if(size_filters.length && filterLifeStage !== 'treats-for-puppies') {
      for(var s = 0; s < size_filters.length; s++) {
        var filterLevel = size_filters[s];
        for(var p = 0; p < prod_filters.length; p++) {
          // final_filters.push(size_filters[s]+prod_filters[p]);
          filterLevel += prod_filters[p];
        }
        final_filters.push(filterLevel);
      }
    } else {
      for(var p = 0; p < prod_filters.length; p++) {
        // final_filters.push(size_filters[s]+prod_filters[p]);
        final_filters.push(prod_filters[p]);
      }
    }

    console.log(final_filters);

    $product_grid.isotope({
      filter: final_filters.join(',')
    });

    $('.product-quiz-header').removeClass('hide');

    if($('#quiz-selections').length) {
      setTimeout(function() {
        $('html, body').animate({
            scrollTop: $('#quiz-selections').offset().top - ($('header.header').outerHeight()  || 0) - ($('.is-dropdown-submenu:visible').outerHeight()  || 0) - 30
        }, 500);
      }, 500);
    }
  }


  if( $('.product-slider-main').length && $('.product-slider-nav').length ) {

    $('.product-slider-main .slide img').on('load', function() {
      var imgWidth = $(this).outerWidth();
      var imgHeight = $(this).outerHeight();

      if(imgWidth > imgHeight) {
        $(this).addClass('landscape');
      } else {
        $(this).addClass('portrait');
      }
    });

    var mainOptions = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
    }

    if($('.product-slider-nav .slide').length > 1) {
      mainOptions.asNavFor = '.product-slider-nav';
    }

    var productMainSlider = $('.product-slider-main').slick(mainOptions);

    if($('.product-slider-nav .slide').length > 1) {
      var navOptions = {
        // slidesToScroll: 1,
        asNavFor: '.product-slider-main',
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        centerMode: true
      };

      if($('.product-slider-nav .slide').length < 3) {
        navOptions.slidesToShow = $('.product-slider-nav .slide').length;
      }

      // if($('.product-slider-nav .slide').length > 3) {
      //   navOptions.slidesToShow = 3;
      // } else if($('.product-slider-nav .slide').length > 2){
      //   navOptions.slidesToShow = $('.product-slider-nav .slide').length - 1;
      // } else {
      //   navOptions.slidesToShow = $('.product-slider-nav .slide').length;
      // }

      // console.log(navOptions);

      var productNavSlider = $('.product-slider-nav').slick(navOptions);
    }
  }

  $('.size-select [name="product_sizes"]').change(function() {
    checkSizeSelector();
  });

  $('#product-buy-now').click(function() {
    var sizeToShow = $('.size-select [name="product_sizes"]:checked').val();
    $('.buy-now-list [data-links-for-size]').each(function() {
      $(this).addClass('hide');
    });
    $('.buy-now-list [data-links-for-size="'+sizeToShow+'"]').removeClass('hide');
  });

  function checkSizeSelector() {
    if($('#product-buy-now').prop('disabled')) {
      $('#product-buy-now').prop('disabled', false);
    }
  }

  checkSizeSelector();


  //replace Buy Now button for Winter Shapes
  //if ($("body").hasClass("postid-30902")) {
    //if ($('.single-title:contains("Winter Shapes")').length > 0) {
    //$( "#product-buy-now" ).replaceWith( "<h3>Coming Soon</h3>" );
    //$("#product-buy-now").prop("disabled",true);
    //$('#product-buy-now').html('Coming Soon');
    //}

});
